import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toastSuccess } from '../../components/partials/Toast/Toast';
import { CAMPAIGN_FORM_VALUES } from '../../pages/private/Campaign/forms/schema';
import useApiStore from '../../store/useApiStore';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';

interface PAYLOAD
  extends Omit<
    CAMPAIGN_FORM_VALUES,
    'stateOrProvince' | 'city' | 'radiusInMiles' | 'standardStatus' | 'listAgentEmailOmitIfNotExists' | 'mlsSource'
  > {
  id: string;
  campaignSearchQuery: {
    mlsSource?: string;
    listingContractDateFrom?: string;
    listingContractDateTo?: string;
    listingContractDateGreaterThanDays?: number;
    listingContractDateLessThanDays?: number;
    listPriceFrom?: number;
    listPriceTo?: number;
    yearBuiltFrom?: number;
    yearBuiltTo?: number;
    city: string;
    stateOrProvince: string;
    radiusInMiles: number;
    standardStatus?: string;
    listAgentEmailOmitIfNotExists: boolean;
  };
}

export default function useUpdateCampaign() {
  const { onError } = useApiStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PAYLOAD) => {
      const api = new Api({ onError });

      const { id, ...rest } = payload;

      const data = await api.put({
        url: `api/v1/campaigns/${id}`,
        payload: { ...rest, zoneId: Intl.DateTimeFormat().resolvedOptions().timeZone },
      });

      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully Updated Campaign.');

      queryClient.invalidateQueries({ queryKey: [CAMPAIGNS_KEY] });
    },
  });
}
